module.exports = __webpack_public_path__ + "img/hero-02.1576a62c.jpg";